module.exports = __webpack_public_path__ + "static/img15-9290adeb20be76e6c611c1f3b392df1c.jpg";